import { toNDecimal, formatDate } from '../utils';

export const EXCEL_EXPORT_VARIANTS = {
    BATCHES: 'batches',
    ACCOUNTS_PAYABLE_DETAILED: 'accounts_payable_detailed',
    ACCOUNTS_PAYABLE_BY_VENDOR: 'accounts_payable_by_vendor',
    ACCOUNTS_PAYABLE_BY_MONTH: 'accounts_payable_by_month',
    ACCOUNTS_PAYABLE_BY_VENDOR_BY_MONTH: 'accounts_payable_by_vendor_by_month',
    ACCOUNTS_PAYABLE_BY_MONTH_BY_VENDOR: 'accounts_payable_by_month_by_vendor',
    PAYMENT_VARIANCE_DETAILED: 'payment_variance_detailed',
    PAYMENT_VARIANCE_SUMMARY: 'payment_variance_summary'
};

export const excelExportSchemas = {
    [EXCEL_EXPORT_VARIANTS.BATCHES]: {
        sheetName: 'Batches',
        header: [
            'Batch no',
            'Vendor name',
            'Batch date',
            'Amount',
            'Vendor reference #',
            'From date',
            'Thru date',
            'Breakage',
            'Vouchers',
            'Invoice no #'
        ],
        filenamePrefix: 'batches_export',
        api: 'batches',
        operation: 'listBatches',
        apiResponseKey: 'batches',
        mapper: batch => [
            batch.batchNo,
            batch.vendorName,
            formatDate(batch.batchDate),
            batch.amount.toFixed(2),
            batch.vendorReference || 'N/A',
            formatDate(batch.from),
            formatDate(batch.to),
            batch.isBreakage ? 'Yes' : 'No',
            batch.bookingItemCount,
            batch.invoiceNum || 'N/A'
        ]
    },
    [EXCEL_EXPORT_VARIANTS.ACCOUNTS_PAYABLE_DETAILED]: {
        sheetName: 'Accounts Payable',
        header: [
            'Vendor no #',
            'Vendor Name',
            'Payment Date',
            'Total Sales Amount',
            'Total Vendor Net',
            'Margin',
            'Total Tax'
        ],
        filenamePrefix: 'accounts_payable_export',
        api: 'batches',
        operation: 'exportBatches',
        apiResponseKey: 'items',
        mapper: item => [
            item.vendor || '-',
            item.vendorName || '-',
            item?.paymentDate || '-',
            toNDecimal(item.totalSalesAmount),
            toNDecimal(item.net),
            toNDecimal(item.margin),
            toNDecimal(item.tax)
        ]
    },
    [EXCEL_EXPORT_VARIANTS.ACCOUNTS_PAYABLE_BY_MONTH]: {
        sheetName: 'By Month',
        header: ['Month', 'Total Sales Amount', 'Total Vendor Net', 'Total Tax'],
        filenamePrefix: 'accounts_payable_export',
        api: 'batches',
        operation: 'exportBatches',
        apiResponseKey: 'items',
        mapper: item => [
            item.month,
            toNDecimal(item.totalSalesAmount),
            toNDecimal(item.net),
            toNDecimal(item.margin),
            toNDecimal(item.tax)
        ]
    },
    [EXCEL_EXPORT_VARIANTS.ACCOUNTS_PAYABLE_BY_VENDOR]: {
        sheetName: 'By Vendor',
        header: [
            'Vendor no #',
            'Vendor Name',
            'Total Sales Amount',
            'Total Vendor Net',
            'Margin',
            'Total Tax'
        ],
        filenamePrefix: 'accounts_payable_export',
        api: 'batches',
        operation: 'exportBatches',
        apiResponseKey: 'items',
        mapper: item => [
            item.vendor || '-',
            item.vendorName || '-',
            toNDecimal(item.totalSalesAmount),
            toNDecimal(item.net),
            toNDecimal(item.margin),
            toNDecimal(item.tax)
        ]
    },
    [EXCEL_EXPORT_VARIANTS.ACCOUNTS_PAYABLE_BY_VENDOR_BY_MONTH]: {
        sheetName: 'Vendor and Month',
        header: [
            'Vendor no #',
            'Vendor Name',
            'Month',
            'Total Sales Amount',
            'Total Vendor Net',
            'Margin',
            'Total Tax'
        ],
        filenamePrefix: 'accounts_payable_export',
        api: 'batches',
        operation: 'exportBatches',
        apiResponseKey: 'items',
        mapper: item => [
            item.vendor || '-',
            item.vendorName || '-',
            item.month,
            toNDecimal(item.totalSalesAmount),
            toNDecimal(item.net),
            toNDecimal(item.margin),
            toNDecimal(item.tax)
        ]
    },
    [EXCEL_EXPORT_VARIANTS.ACCOUNTS_PAYABLE_BY_MONTH_BY_VENDOR]: {
        sheetName: 'Month and Vendor',
        header: [
            'Month',
            'Vendor no #',
            'Vendor Name',
            'Total Sales Amount',
            'Total Vendor Net',
            'Margin',
            'Total Tax'
        ],
        filenamePrefix: 'accounts_payable_export',
        api: 'batches',
        operation: 'exportBatches',
        apiResponseKey: 'items',
        mapper: item => [
            item.month,
            item.vendor || '-',
            item.vendorName || '-',
            toNDecimal(item.totalSalesAmount),
            toNDecimal(item.net),
            toNDecimal(item.margin),
            toNDecimal(item.tax)
        ]
    },
    [EXCEL_EXPORT_VARIANTS.PAYMENT_VARIANCE_DETAILED]: {
        sheetName: 'Payment Variance Detailed',
        header: [
            'Batch no #',
            'Vendor no #',
            'Vendor Name',
            'From date',
            'To date',
            'Total Sales Amount',
            'Pay amount',
            'Over & Under',
            'Note'
        ],
        filenamePrefix: 'payment_variance_detailed_export',
        api: 'batches',
        operation: 'exportBatches',
        apiResponseKey: 'items',
        mapper: item => [
            item.batchNo,
            item.vendor || '-',
            item.vendorName || '-',
            formatDate(item.fromDate),
            formatDate(item.toDate),
            toNDecimal(item.amountDue),
            toNDecimal(item.payAmount),
            toNDecimal(item.overUnder),
            item.note || '-'
        ]
    },
    [EXCEL_EXPORT_VARIANTS.PAYMENT_VARIANCE_SUMMARY]: {
        sheetName: 'Payment Variance Summary',
        header: ['Batch no #', 'Total Sales Amount', 'Pay amount', 'Over & Under'],
        filenamePrefix: 'payment_variance_summary_export',
        api: 'batches',
        operation: 'exportBatches',
        apiResponseKey: 'items',
        mapper: item => [
            item.batchNo,
            toNDecimal(item.amountDue),
            toNDecimal(item.payAmount),
            toNDecimal(item.overUnder)
        ]
    }
};
